<div *ngIf="initialized" class="card">
  <!-- Header -->
  <header class="card-header bg-light py-3 px-5">
    <div class="d-flex justify-content-between align-items-center">
      <h3 class="h6 mb-0">Exhibit Materials</h3>

      <button type="button" class="close" aria-label="Close" (click)="close()">
        <span aria-hidden="true">×</span>
      </button>
    </div>
  </header>
  <!-- End Header -->

  <!-- Body -->

  <div #questionContainer class="card-body" style="">
    <div *ngIf="!exhibit.materials || exhibit.materials.length == 0" class="text-center">
      <div class="mb-5">
        <p class="font-size-3">No Materials</p>
      </div>
    </div>
    <div>
      <table>
        <tr *ngFor="let material of exhibit.materials">
          <td>
            <h4>
              <a (click)="materialsDownloaded()" href="/fetchMaterial?fileName={{ material.blobPath | encodeUrl }}&downloadName={{ material.description }}&access_token={{ auth.getToken() }}"><img style="width: 40px" src="../../assets/filetypes/{{ material.fileType }}.png" /> {{ material.description }}</a>
            </h4>
          </td>
        </tr>
      </table>
    </div>
  </div>
</div>
